// Modules
import React, { createContext, useState, useContext } from 'react'

// Application
import { Lab } from 'typings/laboratory'
import { ToastData } from 'typings/components'
import { HelpModalProps } from 'constants/helpmodal'
import { useAppHook } from 'hooks'
import { AccountExistsModalProps } from 'constants/accountExistsModal'

interface ContextData {
    state: {
        toast: ToastData
        helpModal?: HelpModalProps
        accountExistsModal?: AccountExistsModalProps
        onboardingModalStories?: boolean
        labOnboarding?: Lab
    }
    operations: {
        setToast: (value: ToastData) => void
        setHelpModal: (value: HelpModalProps | undefined) => void
        setAccountExistsModal: (value: AccountExistsModalProps | undefined) => void
        setOnboardingModalStories: (value: boolean) => void
        setLabOnboarding: (value: Lab) => void
    }
}

const AppContext = createContext<ContextData>({} as ContextData)

export const AppProvider: React.FC = ({ children }) => {
    const [toast, setToast] = useState<ToastData>({ show: false, message: '', link: undefined })
    const [helpModal, setHelpModal] = useState<HelpModalProps>()
    const [accountExistsModal, setAccountExistsModal] = useState<AccountExistsModalProps>()
    const [onboardingModalStories, setOnboardingModalStories] = useState<boolean>(false)
    const [labOnboarding, setLabOnboarding] = useState<Lab>()

    return (
        <AppContext.Provider
            value={{
                state: {
                    toast,
                    helpModal,
                    accountExistsModal,
                    onboardingModalStories,
                    labOnboarding,
                },
                operations: {
                    setToast,
                    setHelpModal,
                    setAccountExistsModal,
                    setOnboardingModalStories,
                    setLabOnboarding,
                },
            }}
        >
            {children}
        </AppContext.Provider>
    )
}

export function useAppContext(): ContextData {
    const context = useContext(AppContext)
    if (context === undefined) {
        throw new Error('useApp value is undefined. Make sure you use the AuthProvider before using the context.')
    }
    return context
}

export { useAppHook as useApp }
